import { SECOND } from '../utils/time';

const RoundCount = 5;
const RoundPass = Math.floor(RoundCount * 0.6);

export default {
    name: 'Stroop task',
    level: [
        {
            practice: true,
            name: 'ทดลองเล่น',
            displayTime: 5 * SECOND,
            cooldownTime: 1 * SECOND,
            round: 2,
            score: 1,
            passScore: 2,
        },
        {
            name: 'ระดับที่ 1',
            level: 1,
            displayTime: 5 * SECOND,
            cooldownTime: 1 * SECOND,
            round: RoundCount,
            score: 1,
            passScore: RoundPass,
        },
        {
            name: 'ระดับที่ 2',
            level: 2,
            displayTime: 4 * SECOND,
            cooldownTime: 1 * SECOND,
            round: RoundCount,
            score: 1,
            passScore: RoundPass,
        },
        {
            name: 'ระดับที่ 3',
            level: 3,
            displayTime: 3 * SECOND,
            cooldownTime: 1 * SECOND,
            round: RoundCount,
            score: 1,
            passScore: RoundPass,
        }
    ],
}